// Challenge + interactive deliverables checklist per project (EN/ES).
export const projectExtras = {
  food: {
    en: {
      challenge: "Turn one home-cooked dish into a magazine-style spread using only window light and simple props.",
      checklist: ["1 overhead flat-lay shot", "2 shots at a 45-degree angle", "1 eye-level shot", "1 detail close-up", "All 5 final photos edited"],
    },
    es: {
      challenge: "Convierte un plato casero en una portada de revista usando solo luz de ventana y accesorios simples.",
      checklist: ["1 toma cenital (flat lay)", "2 tomas a 45 grados", "1 toma a nivel de ojo", "1 detalle de cerca", "Las 5 fotos finales editadas"],
    },
  },
  portrait: {
    en: {
      challenge: "Photograph the same person three ways and show three different sides of their personality.",
      checklist: ["1 tight headshot", "1 environmental portrait", "1 creative portrait (unusual light, angle or mood)", "3 final edited photos"],
    },
    es: {
      challenge: "Fotografía a la misma persona de tres formas y muestra tres lados distintos de su personalidad.",
      checklist: ["1 primer plano cerrado", "1 retrato ambiental", "1 retrato creativo (luz, ángulo o estado de ánimo inusual)", "3 fotos finales editadas"],
    },
  },
  landscape: {
    en: {
      challenge: "Go out at golden hour and capture a scene with a clear foreground, midground and background.",
      checklist: ["2 wide views", "1 shot with leading lines", "1 shot with a strong foreground", "1 panoramic or vertical frame", "All 5 final photos edited"],
    },
    es: {
      challenge: "Sal en la hora dorada y captura una escena con primer plano, plano medio y fondo bien definidos.",
      checklist: ["2 vistas amplias", "1 toma con líneas guía", "1 toma con primer plano fuerte", "1 encuadre panorámico o vertical", "Las 5 fotos finales editadas"],
    },
  },
  fashion: {
    en: {
      challenge: "Create a mini lookbook where the outfit is the hero and the city is the stage.",
      checklist: ["3 full-body looks", "2 three-quarter shots", "At least 2 different locations", "5 final edited photos"],
    },
    es: {
      challenge: "Crea un mini lookbook donde la ropa sea la protagonista y la ciudad el escenario.",
      checklist: ["3 looks de cuerpo completo", "2 tomas de 3/4", "Al menos 2 locaciones diferentes", "5 fotos finales editadas"],
    },
  },
  street: {
    en: {
      challenge: "Spend one hour in a public place and capture real, unstaged moments of everyday life.",
      checklist: ["10 candid shots in 1 hour", "1 shot showing contrast (old/new, light/shadow)", "1 shot with a story or emotion", "5 selects with basic editing"],
    },
    es: {
      challenge: "Pasa una hora en un lugar público y captura momentos reales y espontáneos de la vida cotidiana.",
      checklist: ["10 tomas espontáneas en 1 hora", "1 toma con contraste (viejo/nuevo, luz/sombra)", "1 toma con historia o emoción", "5 seleccionadas con edición básica"],
    },
  },
  architecture: {
    en: {
      challenge: "Find the lines, symmetry and repeating patterns hidden in the buildings around you.",
      checklist: ["1 symmetrical shot", "1 shot with leading lines", "1 detail or pattern shot", "1 shot with a person for scale", "1 shot at blue hour or in dramatic light"],
    },
    es: {
      challenge: "Encuentra las líneas, la simetría y los patrones repetidos ocultos en los edificios a tu alrededor.",
      checklist: ["1 toma simétrica", "1 toma con líneas guía", "1 toma de detalle o patrón", "1 toma con una persona para escala", "1 toma en hora azul o con luz dramática"],
    },
  },
  wildlife: {
    en: {
      challenge: "Be patient and photograph an animal or insect showing natural behavior in its habitat.",
      checklist: ["1 animal portrait with sharp eyes", "1 action or behavior shot", "1 shot of the animal in its environment", "1 creative shot (silhouette or backlit)", "All 5 final photos edited"],
    },
    es: {
      challenge: "Ten paciencia y fotografía un animal o insecto mostrando su comportamiento natural en su hábitat.",
      checklist: ["1 retrato del animal con ojos nítidos", "1 toma de acción o comportamiento", "1 toma del animal en su entorno", "1 toma creativa (silueta o contraluz)", "Las 5 fotos finales editadas"],
    },
  },
  product: {
    en: {
      challenge: "Make an everyday object look ready for an online store using a DIY home studio.",
      checklist: ["1 front view on a clean background", "1 45-degree angle shot", "1 top-down shot", "1 detail close-up", "1 lifestyle context shot"],
    },
    es: {
      challenge: "Haz que un objeto cotidiano luzca listo para una tienda online usando un estudio casero.",
      checklist: ["1 vista frontal sobre fondo limpio", "1 toma a 45 grados", "1 toma cenital", "1 detalle de cerca", "1 toma de contexto lifestyle"],
    },
  },
  night: {
    en: {
      challenge: "Use your tripod and long exposures to reveal light the eye can't see at night.",
      checklist: ["1 light-trail shot", "1 starry-sky shot", "1 light-painting shot", "1 blue-hour cityscape", "1 creative long exposure"],
    },
    es: {
      challenge: "Usa tu trípode y largas exposiciones para revelar la luz que el ojo no ve de noche.",
      checklist: ["1 toma de estelas de luz", "1 toma de cielo estrellado", "1 toma de light painting", "1 paisaje urbano en hora azul", "1 larga exposición creativa"],
    },
  },
  macro: {
    en: {
      challenge: "Explore a tiny world and reveal textures and details invisible to the naked eye.",
      checklist: ["1 insect or bug", "1 flower detail", "1 texture study (fabric, wood or metal)", "1 water drop", "All 5 final photos edited"],
    },
    es: {
      challenge: "Explora un mundo diminuto y revela texturas y detalles invisibles a simple vista.",
      checklist: ["1 insecto", "1 detalle de flor", "1 estudio de textura (tela, madera o metal)", "1 gota de agua", "Las 5 fotos finales editadas"],
    },
  },
  sports: {
    en: {
      challenge: "Freeze the peak moment of a game or workout and make the energy jump off the screen.",
      checklist: ["1 frozen peak-action moment", "1 panning shot with blurred background", "1 celebration or emotion shot", "1 wide establishing shot", "All 5 final photos edited"],
    },
    es: {
      challenge: "Congela el momento cumbre de un partido o entrenamiento y haz que la energía salte de la pantalla.",
      checklist: ["1 momento cumbre congelado", "1 paneo con fondo borroso", "1 toma de celebración o emoción", "1 toma amplia de establecimiento", "Las 5 fotos finales editadas"],
    },
  },
  event: {
    en: {
      challenge: "Cover a real gathering from start to finish and tell its story in pictures.",
      checklist: ["2 wide venue/atmosphere shots", "3 candid moments", "2 posed group shots", "2 detail or decor shots", "1 creative shot (silhouette, reflection or motion)"],
    },
    es: {
      challenge: "Cubre una reunión real de principio a fin y cuenta su historia en imágenes.",
      checklist: ["2 tomas amplias de ambiente", "3 momentos espontáneos", "2 fotos grupales posadas", "2 tomas de detalle o decoración", "1 toma creativa (silueta, reflejo o movimiento)"],
    },
  },
  blackwhite: {
    en: {
      challenge: "Spend a day seeing only in black and white — let light, contrast and texture tell the story.",
      checklist: ["2 high-contrast images", "2 low-key (shadow-dominant) images", "2 texture or detail studies", "1 high-key image", "1 environmental portrait"],
    },
    es: {
      challenge: "Pasa un día viendo solo en blanco y negro: deja que la luz, el contraste y la textura cuenten la historia.",
      checklist: ["2 imágenes de alto contraste", "2 imágenes de clave baja (dominadas por sombra)", "2 estudios de textura o detalle", "1 imagen de clave alta", "1 retrato ambiental"],
    },
  },
};
